#import '../../fragments/userNotification.fragment.graphql'

mutation dismiss($id: String!) {
  dismiss(input: { id: $id }) {
    notifications {
      ...UserNotificationFragment
    }
  }
}
